import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../utils/api";
import { RootState } from "../../rootReducer";

// Asigna organizations al usuario bajo el perfil asignado
export const assignOrganizations = createAsyncThunk(
    "userProfileOrganization/assignOrganizations",
    async (arg, { rejectWithValue, getState }) => {
        try {
            const state = getState() as RootState;
            const selectedOrganizations = state.userProfileOrganization.selectedOrganizations;
            let organizationsToSave = [...selectedOrganizations];
            const assignedOrganizations = state.userProfileOrganization.assignedOrganizations;
            const idsToDelete: string[] = [];

            // Se comprueba si los organizations ya asignados se encuentran dentro de los seleccionados.
            // Si los encuentra los elimina del listado para crear registros (idsOrganizationsToSave).
            // Si no los encuentra guarda el id en listado para eliminar registros (IdsToDelete).
            assignedOrganizations.forEach(async element => {
                if (organizationsToSave.find(({ id }) => id === element.organization.id)) {
                    organizationsToSave = organizationsToSave.filter(({ id }) => id !== element.organization.id);
                } else {
                    idsToDelete.push(element.id.toString());
                }

            });
            // Genera listado de ids de organizations para guardar registros
            const idsOrganizationsToSave = organizationsToSave.map(element => element.id);
            const token = localStorage.getItem("token");
            const headers = new Headers();
            headers.append("Authorization", `Bearer ${token}`);
            headers.append("Content-Type", "application/json");

            // Eliminar registros
            if (idsToDelete.length > 0) {
                const url = new URL(`${api.baseURL}userprofileorganization/delete-list`);
                let response = await fetch(url.toJSON(), {
                  body: JSON.stringify({
                    toDelete: idsToDelete.toString(),
                  }),
                  method: "POST",
                  headers: headers
                });
                if (!response.ok) {
                  throw response.statusText;
                }
            } 
            
            // Crea registros
            if (idsOrganizationsToSave.length > 0) {
                const url = new URL(`${api.baseURL}userprofileorganization/create-list`);
                let response = await fetch(url.toJSON(), {
                  body: JSON.stringify({
                    user: state.userProfileOrganization.user.id,
                    profile: state.userProfileOrganization.profile.id,
                    toAddOrganizationsIds: idsOrganizationsToSave.toString(),
                  }),
                  method: "POST",
                  headers: headers
                });
                if (!response.ok) {
                  throw response.statusText;
                }
            }
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);